import { FormBase } from 'core/components';

export default class InsuranceManagementEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'INSURANCE_MANAGEMENT.EDIT.NAME_LABEL',
                    placeholder: 'INSURANCE_MANAGEMENT.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
                {
                    name: 'abbreviatedName',
                    label: 'INSURANCE_MANAGEMENT.EDIT.ABBREVIATED_NAME_LABEL',
                    placeholder: 'INSURANCE_MANAGEMENT.EDIT.ABBREVIATED_NAME_PLACEHOLDER',
                    rules: ['string'],
                },
                {
                    name: 'description',
                    label: 'INSURANCE_MANAGEMENT.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'INSURANCE_MANAGEMENT.EDIT.DESCRIPTION_PLACEHOLDER',
                    type: 'textarea',                    
                    rules: 'string'
                },
                {
                    name: 'primarySort',
                    label: 'INSURANCE_ORDERING.CREATE.PRIMARY_SORT_LABEL',
                    type: 'integer',
                },
                {
                    name: 'secondarySort',
                    label: 'INSURANCE_ORDERING.CREATE.SECONDARY_SORT_LABEL',
                    type: 'integer'
                },
                {
                    name: "pricingGroupId",
                    label: "Pricing Group",
                    placeholder: "Select Pricing Group",
                    rules: 'required'
                },
                {
                    name: "placeOfServiceId",
                    label: "POS",
                    placeholder: "Select a POS",
                    rules: 'required'
                },
            ],
        };
    }
}
